module.exports = __webpack_public_path__ + "media/images/landings/promotion_2/ogp-44c4163b0bcfc34410479bc55cc94ddd.png";